import { useListState } from '../../../components/list';

export type SynonymListFilter = { keyword: string; warnedOnly: boolean };

const DEFAULT_FILTER: SynonymListFilter = { keyword: '', warnedOnly: false };

/**
 * 동의어 목록 상태 — URL 이 정본이다(목록 키트 · AMZUWEB-684).
 *
 * 동의어는 검색 사전의 **기본 탭**이라 `tab` 파라미터 없이 쓴다. 목록 키트는 URL 쿼리를 통째로 다시 쓰므로
 * 다른 탭의 `tab` 값을 남기지 못하는데, 기본 탭이면 그럴 필요가 없다.
 */
export const useSynonymListState = () =>
  useListState<SynonymListFilter>({
    defaultFilter: DEFAULT_FILTER,
    parse: (params) => ({
      keyword: params.get('keyword') ?? '',
      warnedOnly: params.get('warnedOnly') === 'true',
    }),
    serialize: (filter) => ({
      ...(filter.keyword.trim() ? { keyword: filter.keyword.trim() } : {}),
      ...(filter.warnedOnly ? { warnedOnly: 'true' } : {}),
    }),
    defaultPageSize: 50,
  });
